import { render, staticRenderFns } from "./d-book-user-review-entry.vue?vue&type=template&id=10ed1f9d&scoped=true&"
import script from "./d-book-user-review-entry.vue?vue&type=script&lang=js&"
export * from "./d-book-user-review-entry.vue?vue&type=script&lang=js&"
import style0 from "./d-book-user-review-entry.vue?vue&type=style&index=0&id=10ed1f9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ed1f9d",
  null
  
)

export default component.exports